module.exports = __webpack_public_path__ + "assets/img/sh22.53edf940.png";